export default {"src":"/_next/static/media/personalise-your-price.9598cf02.svg","height":75,"width":100};